import { Grid } from "@mantine/core";
import MantineSwitchButton from "../../../../components/MantineSwitchButton/MantineSwitchButton";

// En una venta de pack, el alumno se agrega al grupo de WhatsApp de cada curso del pack
// que tenga grupo automatizado (lo resuelve el backend). has_wp_group va junto al switch.
const PackWPGroupSwitch = ({ form }) => (
    <Grid.Col span={12}>
        <MantineSwitchButton
            checked={!!form.values.is_already_in_wp}
            onChange={() => {
                const next = !form.values.is_already_in_wp;
                form.setFieldValue("is_already_in_wp", next);
                form.setFieldValue("has_wp_group", next);
            }}
            label={<span>¿Deseas <strong>agregar automáticamente</strong> al alumno a los grupos de WP de los cursos del pack?</span>}
        />
    </Grid.Col>
);

export default PackWPGroupSwitch;
